import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { queryClient } from './app/query-client'
import { router } from './app/router'
import { I18nProvider } from './i18n'
import { AuthLifecycle } from './auth/lifecycle'
import './styles/index.css'
const container = document.getElementById('app')
if (!container) throw new Error('Application container missing')
createRoot(container).render(<StrictMode><I18nProvider><QueryClientProvider client={queryClient}><AuthLifecycle><RouterProvider router={router} /></AuthLifecycle><Toaster richColors /></QueryClientProvider></I18nProvider></StrictMode>)
